
export const StagingUrl = 'https://api-dot-admin-tools-dot-warroom-test.rj.r.appspot.com/';
export const ProductionUrl = 'https://api-dot-admin-tools-dot-stilinguemvp.appspot.com/';
